module.exports = __webpack_public_path__ + "static/media/cozy9016.50953610.jpg";